<template>
  <v-form class="mb-3" autocomplete="off" @submit.prevent="">
    <v-row class="filters" align="center" justify="start">
      <v-col class="mt-0 pt-0 pr-11">
        <v-row class="mt-3">
          <v-col cols="12" sm="6" md="4" lg="3" class="pb-0">
            <v-text-field
              v-model.trim="filters.searchTerm"
              label="Hledat"
              outlined
              dense
              background-color="white"
              append-icon="mdi-magnify"
              :prepend-icon="filters.searchTerm ? 'mdi-close' : 'mdi-none'"
              @click:append="filter"
              @click:prepend.prevent="removeFromFilter('searchTerm')"
              @keydown.enter="filter()"
            />
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pb-0">
            <v-text-field
              v-model="filters.ids"
              v-mask="'######'"
              label="Id zákazníka"
              outlined
              dense
              background-color="white"
              :prepend-icon="filters.ids ? 'mdi-close' : 'mdi-none'"
              min="1"
              step="1"
              @click:prepend="filters.ids = null"
              @keydown.enter="filter()"
            />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="3"
            class="pb-0 filter-datepicker filter-datepicker--from"
          >
            <v-text-field
              v-model.trim="dateFromFormatted"
              outlined
              dense
              background-color="white"
              label="Datum vytvoření od"
              append-icon="mdi-calendar-arrow-left"
              :prepend-icon="dateFromFormatted ? 'mdi-close' : 'mdi-none'"
              @blur="filters.dateSince = setParsedDateSince(dateFromFormatted)"
              @click:prepend="filters.dateSince = null"
              @click:append="menuForDateFrom = true"
            />

            <v-menu
              ref="menuForDateFrom"
              v-model="menuForDateFrom"
              attach=".filter-datepicker--from"
              :close-on-content-click="false"
              transition="scale-transition"
              max-width="290px"
              min-width="290px"
            >
              <v-date-picker
                v-model="filters.dateSince"
                :first-day-of-week="1"
                :max="maxForDateFrom"
                no-title
                @input="menuForDateFrom = false"
              />
            </v-menu>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="3"
            class="pb-0 filter-datepicker filter-datepicker--to"
          >
            <v-text-field
              v-model.trim="dateToFormatted"
              outlined
              dense
              background-color="white"
              label="Datum vytvoření do"
              append-icon="mdi-calendar-arrow-right"
              :prepend-icon="dateToFormatted ? 'mdi-close' : 'mdi-none'"
              @blur="filters.dateUntil = setParsedDateUntil(dateToFormatted)"
              @click:prepend="filters.dateUntil = null"
              @click:append="menuForDateTo = true"
            />
            <v-menu
              ref="menuForDateTo"
              v-model="menuForDateTo"
              attach=".filter-datepicker--to"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <v-date-picker
                v-model="filters.dateUntil"
                :first-day-of-week="1"
                :max="maxForDateTo"
                :min="minForDateTo"
                no-title
                @input="menuForDateTo = false"
              />
            </v-menu>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="3"
            class="pb-0 filter-datepicker filter-datepicker--customer-birthday-from"
          >
            <v-text-field
              v-model.trim="customerBirthdayFromFormatted"
              outlined
              dense
              background-color="white"
              label="Datum narození od"
              append-icon="mdi-calendar-arrow-left"
              :prepend-icon="customerBirthdayFromFormatted ? 'mdi-close' : 'mdi-none'"
              @blur="filters.birthdaySince = setParsedBirthdaySince(customerBirthdayFromFormatted)"
              @click:prepend="filters.birthdaySince = null"
              @click:append="menuForCustomerBirthdayFrom = true"
            />

            <v-menu
              ref="menuForCustomerBirthdayFrom"
              v-model="menuForCustomerBirthdayFrom"
              attach=".filter-datepicker--customer-birthday-from"
              :close-on-content-click="false"
              transition="scale-transition"
              max-width="290px"
              min-width="290px"
            >
              <v-date-picker
                v-model="filters.birthdaySince"
                :first-day-of-week="1"
                :max="maxForDateFrom"
                no-title
                @input="menuForCustomerBirthdayFrom = false"
              />
            </v-menu>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="3"
            class="pb-0 filter-datepicker filter-datepicker--customer-birthday-to"
          >
            <v-text-field
              v-model.trim="customerBirthdayToFormatted"
              outlined
              dense
              background-color="white"
              label="Datum narození do"
              append-icon="mdi-calendar-arrow-right"
              :prepend-icon="customerBirthdayToFormatted ? 'mdi-close' : 'mdi-none'"
              @blur="filters.birthdayUntil = setParsedBirthdayUntil(customerBirthdayToFormatted)"
              @click:prepend="filters.birthdayUntil = null"
              @click:append="menuForCustomerBirthdayTo = true"
            />
            <v-menu
              ref="menuForDateTo"
              v-model="menuForCustomerBirthdayTo"
              attach=".filter-datepicker--customer-birthday-to"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <v-date-picker
                v-model="filters.birthdayUntil"
                :first-day-of-week="1"
                :max="maxForDateTo"
                :min="minForDateTo"
                no-title
                @input="menuForCustomerBirthdayTo = false"
              />
            </v-menu>
          </v-col>
        </v-row>
        <v-row class="mt-3">
          <v-col cols="12" sm="6" md="4" lg="3" class="pb-0">
            <v-checkbox
              v-model.trim="filters.pendingVerification"
              class="ma-0 pt-2 pb-2"
              label="Čeká na ověření účtu"
              :prepend-icon="'mdi-none'"
              @keydown.enter="filter()"
            />
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pb-0">
            <v-checkbox
              v-model.trim="filters.pendingDeletion"
              class="ma-0 pt-2 pb-2"
              label="Čeká na zrušení účtu"
              :prepend-icon="'mdi-none'"
              @keydown.enter="filter()"
            />
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pb-0">
            <v-checkbox
              v-model.trim="filters.pendingDocument"
              class="ma-0 pt-2 pb-2"
              label="Čeká na ověření dokladu"
              :prepend-icon="'mdi-none'"
              @keydown.enter="filter()"
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" class="pt-0 pr-11 pb-6 text-right">
        <v-btn depressed height="40px" min-width="130px" outlined @click="resetFilter">
          Zrušit filtr
        </v-btn>

        <v-btn
          depressed
          height="40px"
          min-width="130px"
          color="primary"
          class="ml-4"
          @click="filter"
        >
          Filtrovat
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import parseDate from '@/utils/parseDate'

export default {
  name: 'CustomersFilters',
  data() {
    return {
      dateFromFormatted: null,
      dateToFormatted: null,
      menuForDateFrom: false,
      menuForDateTo: false,
      customerBirthdayFromFormatted: null,
      customerBirthdayToFormatted: null,
      menuForCustomerBirthdayFrom: false,
      menuForCustomerBirthdayTo: false,
      filters: {
        searchTerm: null,
        ids: null,
        dateSince: null,
        dateUntil: null,
        birthdaySince: null,
        birthdayUntil: null,
        pendingVerification: null,
        pendingDocument: null,
        pendingDeletion: null,
      },
    }
  },
  computed: {
    filtersFilled() {
      let state = false
      Object.keys(this.filters).forEach((filter) => {
        if (filter !== 'searchTerm') {
          if (this.filters[filter]) {
            state = true
            return true
          }
        }
        return state
      })
      return state
    },
    maxForDateFrom() {
      if (this.filters.dateUntil) {
        return new Date(this.filters.dateUntil).toISOString()
      }
      return new Date().toISOString()
    },
    maxForDateTo() {
      return new Date().toISOString()
    },
    minForDateTo() {
      if (this.filters.dateSince) {
        return new Date(this.filters.dateSince).toISOString()
      }
      return null
    },
  },
  watch: {
    'filters.dateSince': {
      handler() {
        this.dateFromFormatted = this.formatDate(this.filters.dateSince)
      },
    },
    'filters.dateUntil': {
      handler() {
        this.dateToFormatted = this.formatDate(this.filters.dateUntil)
      },
    },
    'filters.birthdaySince': {
      handler() {
        this.customerBirthdayFromFormatted = this.formatDate(this.filters.birthdaySince)
      },
    },
    'filters.birthdayUntil': {
      handler() {
        this.customerBirthdayToFormatted = this.formatDate(this.filters.birthdayUntil)
      },
    },
  },
  async created() {
    this.setFilter()
  },
  methods: {
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    setParsedDateUntil(dateFormatted) {
      this.filters.dateUntil = parseDate(dateFormatted)
      return this.filters.dateUntil
    },
    setParsedDateSince(dateFormatted) {
      this.filters.dateSince = parseDate(dateFormatted)
      return this.filters.dateSince
    },
    setParsedBirthdayUntil(dateFormatted) {
      this.filters.birthdayUntil = parseDate(dateFormatted)
      return this.filters.birthdayUntil
    },
    setParsedBirthdaySince(dateFormatted) {
      this.filters.birthdaySince = parseDate(dateFormatted)
      return this.filters.birthdaySince
    },
    filter() {
      const filters = {
        ...this.filters,
      }
      this.$emit('filter', filters)
    },
    removeFromFilter(removingFilter) {
      this.filters[removingFilter] = null
      this.filter()
    },
    resetFilter() {
      Object.keys(this.filters).forEach((filter) => {
        this.filters[filter] = null
      })
      this.$emit('filter', this.filters)
    },
    setFilter() {
      if (Object.values(this.$route.query)) {
        Object.entries(this.$route.query).forEach((keyValue) => {
          const [key, value] = keyValue
          if (key !== 'searchTerm') {
            this.filters[key] = Number(value) || value
          } else {
            this.filters[key] = value
          }
        })
      }
    },
  },
}
</script>
